import React from "react";
import { Box, Image, Text, VStack } from "@chakra-ui/react";
import Waves from "./ui/Waves";

const LoginLeftPanelWaves = () => {
  return (
    <Box
      display={{ base: "none", md: "block" }}
      width="50%"
      position="relative"
      overflow="hidden"
      bg="#070b14"
    >
      <Box
        position="absolute"
        inset="0"
        bgGradient="radial(circle at 50% 45%, rgba(38,58,105,0.28) 0%, rgba(7,11,20,0.96) 58%, #070b14 100%)"
      >
        <Waves
          lineColor="rgba(156, 187, 255, 0.45)"
          backgroundColor="#070b14"
          waveSpeedX={0.02}
          waveSpeedY={0.01}
          waveAmpX={40}
          waveAmpY={20}
          friction={0.9}
          tension={0.01}
          maxCursorMove={120}
          xGap={12}
          yGap={36}
        />

        <Box
          position="absolute"
          inset="0"
          display="flex"
          alignItems="center"
          justifyContent="center"
          pointerEvents="none"
          px={10}
        >
          <VStack
            spacing={4}
            align="center"
            bg="rgba(9, 15, 28, 0.45)"
            // border="1px solid rgba(170, 196, 255, 0.18)"
            boxShadow="0 24px 60px rgba(0, 0, 0, 0.38)"
            // borderRadius="2xl"
            px={{ md: 8, lg: 10 }}
            py={{ md: 7, lg: 8 }}
            // backdropFilter="blur(6px)"
          >
            <Image
              src="/image.png"
              alt="NoraHuman"
              boxSize={{ md: "108px", lg: "128px" }}
              objectFit="contain"
              borderRadius="xl"
              filter="drop-shadow(0 12px 24px rgba(0, 0, 0, 0.5))"
            />
            <Text
              color="white"
              fontFamily="var(--font-serif)"
              fontSize={{ md: "2xl", lg: "3xl" }}
              fontWeight="800"
              letterSpacing="0.08em"
              textTransform="uppercase"
              textShadow="0 10px 26px rgba(0, 0, 0, 0.55)"
            >
              NoraHuman
            </Text>
            <Text
              color="whiteAlpha.800"
              fontFamily="var(--font-sans)"
              fontSize={{ md: "sm", lg: "md" }}
              fontWeight="500"
              letterSpacing="0.1em"
              textTransform="uppercase"
              textAlign="center"
            >
              Human-Centered HR Platform
            </Text>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginLeftPanelWaves;
